import React from 'react';
import { useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useScrollToSection } from '../../hooks/useScrollToSection';

export default function NavigationLink({ to, children }) {
  const location = useLocation();
  const scrollToSection = useScrollToSection();
  const isActive = location.pathname === to;

  const handleClick = (e) => {
    e.preventDefault();
    if (to === '/' && location.pathname === '/') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }
    scrollToSection(to);
  };

  return (
    <motion.button
      onClick={handleClick}
      className="relative px-4 py-2 group"
      whileHover={{ y: -2 }}
    >
      <span 
        className={`relative z-10 font-medium transition-colors duration-300
          ${isActive ? 'text-red-700' : 'text-gray-900'}`}
      >
        {children}
      </span>
      <span className="absolute inset-0 bg-red-50 scale-0 group-hover:scale-100 transition-transform rounded-lg" />
    </motion.button>
  );
}